import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {WaButtonDirective, WaDialogDirective, WaInputDirective} from "angular-awesome";

export interface ParameterNameDialogData {
  suggestedName: string;
  existingNames: string[];
}

@Component({
    selector: 'app-parameters-create',
    templateUrl: './parameters-create.component.html',
    styleUrls: ['./parameters-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, WaButtonDirective, WaDialogDirective, WaInputDirective]
})
export class ParametersCreateComponent {

  private readonly dialogData = inject<ParameterNameDialogData | null>(DIALOG_DATA, {optional: true});
  private readonly existingNames = new Set(
    (this.dialogData?.existingNames ?? []).map(name => name.trim().toLowerCase())
  );

  name = new FormControl<string>(this.dialogData?.suggestedName ?? '', [
    Validators.required,
    this.uniqueNameValidator()
  ]);

  constructor(private dialogRef: DialogRef<string | null>) {}

  confirm(): void {
    if (!this.stateValid()) return;
    this.dialogRef.close(this.name.value?.trim() ?? null);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private stateValid(): boolean {
    return this.name.valid;
  }

  private uniqueNameValidator(): ValidatorFn {
    return (control): ValidationErrors | null => {
      const value = (control.value ?? '').trim().toLowerCase();
      if (!value) return null;
      return this.existingNames.has(value) ? {nameAlreadyExists: true} : null;
    };
  }
}
